/**
 * Character set - identical to existing split-flap.js
 * Space first for efficient "clear" animations
 */
export const CHARSET = ' ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.,!?:-&';
export const CHARSET_LENGTH = CHARSET.length; // 46
// Board limits
export const MIN_ROWS = 1;
export const MAX_ROWS = 24;
export const MIN_COLS = 1;
export const MAX_COLS = 80;
// Board ID constraints
export const BOARD_ID_MIN_LENGTH = 3;
export const BOARD_ID_MAX_LENGTH = 24;
export const BOARD_ID_PATTERN = /^[a-z0-9-]+$/;
// Playlist ID constraints
export const PLAYLIST_ID_MIN_LENGTH = 3;
export const PLAYLIST_ID_MAX_LENGTH = 24;
export const PLAYLIST_ID_PATTERN = /^[a-z0-9-]+$/;
// Playlist limits
export const MIN_PLAYLIST_DURATION = 5; // Minimum 5 seconds per board
export const MAX_PLAYLIST_DURATION = 3600; // Maximum 1 hour per board
export const MAX_PLAYLIST_ITEMS = 50; // Maximum boards per playlist
// Message limits
export const MAX_MESSAGE_LENGTH = MAX_ROWS * MAX_COLS; // 1,920
// WebSocket configuration
export const WS_PING_INTERVAL_MS = 30000;
export const WS_RECONNECT_BASE_MS = 1000;
export const WS_RECONNECT_MAX_MS = 30000;
export const TIER_LIMITS = {
    free: {
        maxBoards: 1,
        maxPlaylists: 0,
        maxConcurrentViewers: 2,
        customBoardSizes: false,
        watermarkRemoval: false,
        fillScreen: false,
    },
    pro: {
        maxBoards: 5,
        maxPlaylists: 3,
        maxConcurrentViewers: -1, // unlimited
        customBoardSizes: true,
        watermarkRemoval: true,
        fillScreen: true,
    },
    commercial: {
        maxBoards: 20,
        maxPlaylists: 10,
        maxConcurrentViewers: -1, // unlimited
        customBoardSizes: true,
        watermarkRemoval: true,
        fillScreen: true,
    },
};
// Default board size for free tier (fixed)
export const FREE_TIER_BOARD_ROWS = 6;
export const FREE_TIER_BOARD_COLS = 22;
// Pricing in pence (for Stripe)
export const PRICING = {
    pro: {
        monthly: 900, // GBP 9.00
        annual: 9000, // GBP 90.00 (17% off - 2 months free)
    },
    commercial: {
        monthly: 2900, // GBP 29.00
        annual: 29000, // GBP 290.00 (17% off - 2 months free)
    },
};
//# sourceMappingURL=constants.js.map